import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=27714999&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27714999"]])

export default __exports__